<div class="user-row d-flex flex-row align-items-center flex-sm-column align-items-sm-start">
  @if (userCountryFlag || isFaculty) {
    <div class="user-badges">
      @if (!isFaculty) {
        <img alt="user flag" src="{{userCountryFlag}}" class="user-flag" />
      }
      @if (isFaculty) {
        <div class="user-badge">FACULTY</div>
      }
    </div>
  }
  <div class="user-avatar-container">
    @if (userAvatar) {
      <img alt="user avatar" src="data:image/jpg;base64,{{userAvatar}}" class="avatar-responsive-profile rounded-circle"
        />
    }
    @if (!userAvatar) {
      <img alt="user avatar" src="../../../../assets/img/avatar-temp.svg" class="avatar-responsive-profile rounded-circle"
        />
    }
  </div>
  <div class="user-details text-muted mt-1">
    {{displayName}}
    <div> {{displayDate}} </div>
  </div>
</div>